import Alert from 'common/components/alert/Alert';
import AlertType from 'common/types/AlertType';
import React from 'react';
import VerificationStatus from './VerificationStatus';

interface IVerifyAlert {
  status: VerificationStatus;
  filename: string;
}

const VerifyAlert = (props: IVerifyAlert) => {
  let statusMessage;
  let alertType;
  switch (props.status) {
    case VerificationStatus.noDocuments:
      alertType = AlertType.danger;
      statusMessage =
        'Personal identity documentation must be provided before creating an application.';
      break;
    case VerificationStatus.noApplications:
      alertType = AlertType.info;
      statusMessage = `We have received the uploaded document titled "${props.filename}". We will review the document upon submission of your first application.`;
      break;
    case VerificationStatus.pending:
      alertType = AlertType.success;
      statusMessage = `Personal identity documentation has been submitted for review.`;
      break;
    case VerificationStatus.denied:
      alertType = AlertType.danger;
      statusMessage =
        'The identity provided for verification has been rejected. Please re-submit.';
      break;
    case VerificationStatus.approved:
      alertType = AlertType.success;
      statusMessage = 'Form of identity has been reviewed';
      break;
    default:
      alertType = AlertType.danger;
      statusMessage = 'An unknown error has occurred, please try again later';
      break;
  }

  return <Alert type={alertType}>{statusMessage}</Alert>;
};

export default VerifyAlert;
